import { Directive, Input, Inject, Optional } from '@angular/core';
import {
  RvDraggableService,
  RvDraggableItem,
  RvDroppableItem,
} from '../services/rv-draggable.service';

@Directive({
  selector: '[rvDraggableItem]',
  standalone: false,
  host: {
    class: 'rv-draggable-item',
    tabindex: '-1',
    '[attr.data-item-id]': 'itemId',
  },
})
export class RvDraggableItemDirective {
  @Input() rvDraggableItem: RvDraggableItem;

  get itemId(): string {
    if (this.rvDraggableItem && this.draggableService) {
      return this.draggableService.getDraggableItemId(this.rvDraggableItem);
    }
  }

  constructor(
    @Inject(RvDraggableService)
    @Optional()
    public draggableService?: RvDraggableService<
      RvDraggableItem,
      RvDroppableItem
    >
  ) {}
}
